module.exports = __webpack_public_path__ + "static/media/precipitation-03.bcef52b8.svg";